import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class PaymentVoucher {
  async fetch(page, perPage) {
    const response = await ajaxService.get(
      `/payment-vouchers?page=${page}&perPage=${perPage}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewVoucher(id) {
    const response = await ajaxService.get(`/payment-vouchers/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async makePayment(data) {
    const response = await ajaxService.post(`/store-payable`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async fetchExpenseVouchers(data) {
    const response = await ajaxService.post(`/expense-vouchers/payable-vouchers`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async deletePayment(id) {
    const response = await ajaxService.delete(`/payment-vouchers/`, id);
    if (response ?? false) {
      return response;
    }
  }
}

const paymentVoucherService = new PaymentVoucher();
export default paymentVoucherService;
